export default __webpack_public_path__ + "media/images/images/flags/mo-a6a35a66a935b5f2cc366edf195a22ed.png";